var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="card-icon '+
((__t=( config.iconBackground ? "icons-sprite icon-background" : "" ))==null?'':__t)+
'">\n  ';
 if (config.icon) { 
__p+='\n  <i class="icons material-icons">'+
((__t=( config.icon ))==null?'':__t)+
'</i>\n  ';
 } else if (config.spriteIcon) { 
__p+='\n  <span class="icons-sprite '+
((__t=( config.spriteIcon ))==null?'':__t)+
'"></span>\n  ';
 } 
__p+='\n</div>\n\n<div class="card-body">\n\n  ';
 if (config.title) { 
__p+='\n    <h5 class="card-title">'+
((__t=( config.title ))==null?'':__t)+
'</h5>\n  ';
 } 
__p+='\n\n  <p class="card-text">'+
((__t=( config.message ))==null?'':__t)+
'</p>\n\n  ';
 if (config.accentMessage) { 
__p+='\n    <p class="card-accent-message">'+
((__t=( config.accentMessage ))==null?'':__t)+
'</p>\n  ';
 } 
__p+='\n\n  ';
 if (!config.entireCardClickable) { 
__p+='\n    <div class="card-actions">\n      <a class="btn '+
((__t=( config.buttonClasses ))==null?'':__t)+
'" '+
((__t=( (config.url) ? 'href="' + config.url + '" data-route="true"' : 'href="#"' ))==null?'':__t)+
'>\n        '+
((__t=( (config.button) ))==null?'':__t)+
'\n      </a>\n    </div>\n  ';
 } 
__p+='\n\n</div>\n';
}
return __p;
};
